/**
 * Basic model loader, should be extended to configure the loader correctly.
 */
export class ModelLoader {
    loader;


    loadAnimatedModel(url, callback) {
        this.loader.load(url, (model) => {
            this.onLoad(model, callback);
        }, undefined, (error) => {
            this.onError(error, callback);
        });
    }

    /**
     * Called upon successful loading of the model.
     * @param model
     * @param callback
     */
    onLoad(model, callback) {

        callback(model, {
            mixer: null,
            animationMap: {}
        })
    }

    /**
     * Called upon an error loading the model.
     * @param error
     * @param callback
     * @throws err
     */
    onError(error, callback) {
        console.error(`ModelLoader::Error`, error);
        callback(null, {error: error})
    }
}